import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { CWEDescription } from '../../../types';

const fetchCweList = () => {
  return get<CWEDescription[]>('/api/weaknesses');
};

/**
 * React Query hook for fetching the CWE (Common Weakness Enumeration) list.
 */
export function useFetchCweList() {
  return useQuery<CWEDescription[]>({
    queryKey: ['weaknesses'],
    queryFn: fetchCweList,
    // CWE list is a static standard — never changes during a session.
    staleTime: Infinity,
  });
}
